import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "options",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "login-options-configuration" */ "./components/LoginOptionsConfiguration"
      ),
      import("./modules/LoginOptionsConfigurationModule"),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const loginOptionsConfigurationReducer = importedModule1.default;

        injectReducer(store, {
          key: importedModule1.NAME,
          reducer: loginOptionsConfigurationReducer,
        });
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
});
